<template>
  <div class="digital">
    <div class="nav">
      <div
        :class="'nav-item ' + (activedName === 1 ? 'actived' : '')"
        @click="onNavClick(1)"
      >
        全部
      </div>
      <div
        :class="'nav-item ' + (activedName === 2 ? 'actived' : '')"
        @click="onNavClick(2)"
      >
        场景
      </div>
      <div
        :class="'nav-item ' + (activedName === 3 ? 'actived' : '')"
        @click="onNavClick(3)"
      >
        数字藏品
      </div>
    </div>
    <div class="content" v-loading="loading">
      <div v-if="goodsList.length === 0 && !loading" class="empty">
        <p>暂无数字资产</p>
      </div>
      <div class="card" v-for="card in goodsList" :key="card.id">
        <div class="img">
          <img :src="card.imgUrl" alt="" />
        </div>
        <div class="desc">
          <div class="left-title">
            <div class="name">{{ card.name }}</div>
            <div class="date">{{ card.date }}</div>
          </div>
          <div class="mid-title" :title="card.desc">{{ card.desc }}</div>
          <div class="right" @click="copyHash(card.blockchainHash)">
            <img src="../../../assets/images/svg/复制-1.svg" alt="复制" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { getDigitalAssets } from "@/api/digitalAsset";
import { useToast } from "vue-toast-notification";

const $toast = useToast();
const activedName = ref(1);
const goodsList = reactive([]);
const loading = ref(false);

// 格式化日期
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}年${month}月${day}日`;
};

// 获取数字资产列表
const fetchAssets = async (assetType) => {
  loading.value = true;
  try {
    const params = assetType === 1 ? {} : { assetType };
    const res = await getDigitalAssets(params);
    if (res && res.code === 200) {
      goodsList.splice(0, goodsList.length);
      const assets = res.data || [];
      assets.forEach((asset) => {
        goodsList.push({
          id: asset.id,
          imgUrl: asset.assetImage || "/default-asset.png",
          name: asset.assetName,
          date: formatDate(asset.createTime),
          desc: asset.blockchainHash || asset.description || "未上链",
          assetType: asset.assetType,
          blockchainHash: asset.blockchainHash,
          blockchainContractAddress: asset.blockchainContractAddress,
          blockchainTokenId: asset.blockchainTokenId,
        });
      });
    }
  } catch (error) {
    console.error("获取数字资产列表失败:", error);
    $toast.error("获取数字资产列表失败", {
      position: "top",
    });
  } finally {
    loading.value = false;
  }
};

// 切换分类
const onNavClick = (type) => {
  activedName.value = type;
  fetchAssets(type);
};

// 复制区块链哈希
const copyHash = (hash) => {
  if (!hash) {
    $toast.error("该资产尚未上链", {
      position: "top",
    });
    return;
  }
  navigator.clipboard.writeText(hash).then(() => {
    $toast.success("已复制到剪贴板", {
      position: "top",
    });
  });
};

// 组件挂载时加载数据
onMounted(() => {
  fetchAssets(1);
});
</script>

<style lang="scss" scoped>
.digital {
  padding: 0 0 48px;

  img {
    width: 100%;
  }

  .nav {
    display: flex;
    align-items: center;
    margin-top: 0;

    .nav-item {
      color: var(--ux-text-primary);
      font-size: 20px;
      opacity: 0.5;
      margin-right: 48px;
      cursor: pointer;
      font-weight: 350;
    }

    .actived {
      opacity: 1;
    }
  }

  .content {
    margin-top: 40px;
    margin-bottom: 78px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 200px;

    .empty {
      width: 100%;
      text-align: center;
      padding: 100px 0;
      color: #999;
      font-size: 16px;
    }

    .card {
      width: 412px;
      height: 304px;
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 64px;

      &:nth-of-type(3n + 2) {
        margin: 0 50px;
      }

      .desc {
        background-color: var(--ux-glass-bg-subtle);
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 44px;

        .left-title {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .name {
            color: var(--ux-text-primary);
            font-size: 16px;
            margin-bottom: 2px;
          }

          .date {
            color: #7f7f7e;
            font-size: 12px;
          }
        }

        .mid-title {
          color: var(--ux-text-primary);
          font-size: 16px;
          letter-spacing: 2.4px;
        }

        .right {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
